// eslint-disable-next-line no-unused-vars
export default function init(store) {}
